import axios from "axios";

const fanApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

fanApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("fan_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default fanApi;
